import { trackEvent } from '../../../helpers/analytics/trackEvent';
import { logger } from '../../../helpers/logging';
import { HandleMapIconClick } from '../types/types';

import { checkAndReturnPointsOfInterestIconData } from './mapHelpers';

export const handlePointOfInterestClick: HandleMapIconClick = ({
  layerId,
  event,
  map,
  setSelectedIcon,
}) => {
  logger.debug('POI icon click');

  const latitude = event.lngLat.lat;
  const longitude = event.lngLat.lng;

  const features = map.queryRenderedFeatures(event.point, {
    layers: [layerId],
  });

  if (features.length < 1) {
    throw new Error(
      `No Id was found when clicking that icon - Lat: ${latitude}, Lng: ${longitude}`,
    );
  }

  const pointOfInterestId = checkAndReturnPointsOfInterestIconData(features, longitude, latitude);

  void trackEvent({
    name: 'mykiss_explore_marker_clicked',
    properties: {
      type: 'points_of_interest',
    },
  });

  setSelectedIcon({
    drawerViewId: pointOfInterestId ? pointOfInterestId.toString() : undefined,
    drawerView: 'poi',
    latitude,
    longitude,
  });
};
